import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {BuilderTemplatesService} from "../builder-templates.service";
import * as fromStore from "../../../../store";
import {DbStoreState} from "../../../../store/reducers/index";
import {Store} from "@ngrx/store";
import {filter, switchMap} from "rxjs/operators";

@Component({
    selector: 'db-start-ai-builder-dialog',
    templateUrl: './start-ai-builder-dialog.component.html',
    styleUrls: ['./start-ai-builder-dialog.component.scss'],
    standalone: false
})
export class StartAiBuilderDialogComponent extends DialogComponent<null, Boolean> implements OnInit {

  public loading: boolean;
  public firstStep: boolean;
  public userLocalStorage: any;
  public isMobile: boolean;
  @Input() websiteId: any;
  @Input() user?: any;
  constructor(
    private _dialogService: DialogService,
    private _builderTemplatesService: BuilderTemplatesService,
    private _store: Store<DbStoreState>
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
    this.firstStep = true;
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserLocalStorage))
      )
      .subscribe((userLocalStorage: any) => {
        if (userLocalStorage) {
          this.userLocalStorage = userLocalStorage;
        }
      });
  }

  public override close(): void {
    this.result = false;
    this.dialogService.removeDialog(this);
    /*if ( window.innerWidth > 991 && this.user && (!this.userLocalStorage || (this.userLocalStorage && !this.userLocalStorage['dbHideTour']))) {
      this._store.dispatch(new fromStore.ToggleTourSection());
    }*/
  }

  public confirm(): void {
    this.result = true;
    this.close();
  }
  public nextStep() {
    this.firstStep = false;
  }

}
